import { API_URL } from '../config/api';
import axios from 'axios';

const BASE = `${API_URL}/api/reminders`;

export const remindersService = {
  async getAll(username) {
    const res = await axios.get(BASE, { params: { username } });
    return res.data.reminders;
  },

  async getUsers() {
    const res = await axios.get(`${BASE}/users`);
    return res.data.users;
  },

  async searchOrders(q) {
    const res = await axios.get(`${BASE}/search-orders`, { params: { q } });
    return res.data.orders;
  },

  async searchCustomers(term) {
    const res = await axios.get(`${API_URL}/api/customers/search`, { params: { term } });
    return res.data.customers || res.data || [];
  },

  async create(username, title, notes = null, reminderTime = null, extras = {}) {
    const res = await axios.post(BASE, { username, title, notes, reminderTime, ...extras });
    return res.data.reminder;
  },

  async update(id, username, fields) {
    const res = await axios.put(`${BASE}/${id}`, { username, ...fields });
    return res.data.reminder;
  },

  async remove(id, username) {
    await axios.delete(`${BASE}/${id}`, { params: { username } });
  },

  async snooze(id, username, minutes) {
    const res = await axios.post(`${BASE}/${id}/snooze`, { username, minutes });
    return res.data.reminder;
  },

  async sendSMS(id, username) {
    const res = await axios.post(`${BASE}/${id}/send-sms`, { username });
    return res.data;
  }
};
